export default "__VITE_ASSET__BIIGEHga__"